import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as PIXI from 'pixi.js'

const propTypes = {
    canvas: PropTypes.any,
    data: PropTypes.object.isRequired
}

const colors = {
    purple: '#8085FF',
    white: '#FFFFFF',
    orange: '#f47920'
}

const welcomeMessages = {
    1: 'Com a\n presença de:',
    2: 'Presenças de:'
}

class Preview extends Component
{
    constructor(props)
    {
        super(props);
        this.app = this.props.canvas;
        this.first = true;
        this.elements = {};
        this.myRef =  React.createRef();
    }

    componentDidMount()
    {
        this.myRef.current.appendChild(this.app.view);
        //update
        var loader = PIXI.loader
            .add('/images/phone.png')
            .add('/images/photo.png')
            .add('/images/bg.png')
            .add('/images/template-bg-A1.png')
            .add('/images/template-bg-A2.png')
            .add('/images/template-bg-B1.png')
            .add('/images/template-bg-B2.png')
            .add('/images/template-bg-C1.png')
            .add('/images/template-bg-C2.png')
            .load( () => this.update() );
    }

    componentDidUpdate(prevProps)
    {
        if (prevProps !== this.props)
            this.update();
    }

    update()
    {
        const { template, type, bg, city, priceA, priceB, priceC, date, weekday, checkIn, place, address, photos, fontSize } = this.props.data;
        const color = (template === 'A' || template === 'B') ? colors.purple : colors.white;
        const typeInt = Number.parseInt(type) || 0;

        var a = document.getElementById('Fundo');
        if(a != undefined){
            a.style.display = "";
        }
        if(template === 'A'){
            // escnder
            
            console.log(a);

            a.style.display = 'none'; 
        }
console.log("update");
        this.canvasBg(bg);
        this.canvasBase(template, typeInt);
        this.canvasStatic(color, typeInt, template);
        //this.canvasTitle(color);
        this.canvasPrice(priceA, priceB, priceC, color);
        this.canvasCity(city.toUpperCase(), color, fontSize);
        this.canvasDate(date, weekday.toUpperCase(), color);
        this.canvasCheck(checkIn, color);
        this.canvasPlace(place, color);
        this.canvasAddress(address, color);
        this.canvasPhone(typeInt);
        this.canvasPhotos(typeInt, photos);
    }

    canvasBg(bg)
    {
        const exists = this.elements.bg ? true : false;

        if (exists){
            if (bg.file)
                this.loadImage(bg.file)
                .then( res => {
                    this.elements.bg.texture = res;
                });

            this.elements.bg.scale.x = bg.scale;
            this.elements.bg.scale.y = bg.scale;
            return;
        }
            

        /*const file = PIXI.Texture.fromImage(`/images/b2b/bg.png`);
        this.elements.bg = new PIXI.Sprite(file);
        this.app.stage.addChild(this.elements.bg);*/
        const filters = new PIXI.filters.ColorMatrixFilter();
        const file = PIXI.Texture.fromImage(`/images/b2b/background.png`);
        file.baseTexture.scaleMode = PIXI.SCALE_MODES.NEAREST;

        let mask = new PIXI.Graphics();
        mask.lineStyle(0)
            .beginFill(0xFF0000, 1)
            .drawRect(0, 0, 1080, 1080)
            .endFill();

        this.elements.bg = new PIXI.Sprite(file);
        this.elements.bg.anchor.set(.5, .5);
        this.elements.bg.x = 540;
        this.elements.bg.y = 540;
        this.elements.bg.filters = [filters];
        //filters.blackAndWhite(false);

        this.elements.bg.mask = mask;

        this.app.stage.addChild(this.elements.bg);
    }

    canvasBase(template, type)
    {
        const exists = this.elements.base ? true : false;
        const variant = 3;
        if(template == undefined){ template = "A";}
console.log("Typo:"+ variant);
console.log("templat:");
console.log(template);
        const file = PIXI.Texture.fromImage(`/images/b2b/template-bg-${template}${variant}.png`);

        if (exists)
        {
            this.elements.base.texture = file;
            return;
        }

        this.elements.base = new PIXI.Sprite(file);
        this.app.stage.addChild(this.elements.base);
    }

    canvasStatic(color, type, template)
    {
        const colortexto = (template === 'C') ? colors.white : colors.purple;
        if (!this.first){
            this.elements.prices.style.fill = colortexto;
            this.elements.check.style.fill = colortexto;
            
            return;
        }
            

        //load images
        const phoneFile = PIXI.Texture.fromImage(`/images/posts/phone.png`);
        const speakerFile = PIXI.Texture.fromImage(`/images/posts/photo.png`);
        speakerFile.baseTexture.scaleMode = PIXI.SCALE_MODES.NEAREST;
        
        console.log("cor texto"+ colortexto);
        
        //prices labels
        //text top on phone container
        this.elements.prices = new PIXI.Text('Associado: R$\nExpositor: R$\nNão Associado: R$', {
            fontWeight: 400,
            fontSize: 30,
            fontFamily: 'Lato',
            fill: colortexto,
            align: 'left',
            wordWrap: true,
            wordWrapWidth: 396
        });

        this.elements.prices.x = 65;
        this.elements.prices.y = 620;

        //orange box
        this.elements.box = new PIXI.Graphics();
        this.elements.box.beginFill(0xf47920)
                        .drawRect(43, 763, 7, 150)
                        .endFill();
        //checkin text
        this.elements.check = new PIXI.Text('CHECK IN:', {
            fontWeight: 300,
            fontSize: 43,
            fontFamily: 'Lato',
            fill: color,
            align: 'left',
        });

        this.elements.check.x = 65;
        this.elements.check.y = 850;

        //PHONE
        //phone container
        this.elements.container = new PIXI.Container();
        this.elements.container.x = 630;
        this.elements.container.y = 230;
        //phone mockup
        this.elements.phone = new PIXI.Sprite(phoneFile);
        this.elements.phone.x = 0;
        this.elements.phone.y = 0;
        //text top on phone container
        this.elements.welcome = new PIXI.Text(welcomeMessages[type], {
            fontWeight: 300,
            fontSize: 25,
            fontFamily: 'Lato',
            fill: colors.white,
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 396
        });

        this.elements.welcome.anchor.set(0.5, 0);
        this.elements.welcome.x = 200;
        this.elements.welcome.y = 150;

        /*
        * SPEAKERS
        */
        //speaker container A
        this.elements.speakerA = new PIXI.Container();
        this.elements.speakerA.x = 0;
        this.elements.speakerA.y = 250;
        // speaker border
        this.elements.borderA = new PIXI.Graphics();
        this.elements.borderA.lineStyle(0)
            .beginFill(0xFFFFFF, .2)
            .drawCircle(198, 130, 130)
            .endFill();
        //speaker mask
        this.elements.maskA = new PIXI.Graphics();
        this.elements.maskA.lineStyle(0)
            .beginFill(0xFF0000, 1)
            .drawCircle(198, 130, 120)
            .endFill();

        //speaker picture
        this.elements.speakerAPicture = new PIXI.Sprite(speakerFile);
        this.elements.speakerAPicture.interactive = true;
        this.elements.speakerAPicture.buttonMode = true;
        this.elements.speakerAPicture.anchor.set(.5, .5);
        this.elements.speakerAPicture.x = 198;
        this.elements.speakerAPicture.y = 130;
        this.elements.speakerAPicture.scale.x  *= .8;
        this.elements.speakerAPicture.scale.y  *= .8;
        //
        this.elements.speakerAPicture.mask = this.elements.maskA;
        //speaker drad and drop
        this.elements.speakerAPicture
                .on('pointerdown', this.onDragStart)
                .on('pointerup', this.onDragEnd)
                .on('pointerupoutside', this.onDragEnd)
                .on('pointermove', this.onDragMove);

        //speaker name
        this.elements.speakerAName = new PIXI.Text('', {
            fontWeight: 700,
            fontSize: 35,
            fontFamily: 'Lato',
            fill: colors.white,
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 300
        });

        this.elements.speakerAName.anchor.set(0.5, 0);
        this.elements.speakerAName.x = 200;
        this.elements.speakerAName.y = 280;
        //speaker role
        this.elements.speakerARole = new PIXI.Text('', {
            fontWeight: 700,
            fontSize: 25,
            fontFamily: 'Lato',
            fill: colors.white,
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 300
        });

        this.elements.speakerARole.anchor.set(0.5, 0);
        this.elements.speakerARole.x = 200;

        //speaker B
        this.elements.speakerB = new PIXI.Container();
        this.elements.speakerB.x = 60;
        this.elements.speakerB.y = this.elements.speakerA.height + 20;
        this.elements.speakerB.scale.x *= .7;
        this.elements.speakerB.scale.y *= .7;
        //speaker border
        this.elements.borderB = new PIXI.Graphics();
        this.elements.borderB.lineStyle(0)
            .beginFill(0xFFFFFF, .2)
            .drawCircle(198, 130, 130)
            .endFill();
        //speaker mask
        this.elements.maskB = new PIXI.Graphics();
        this.elements.maskB.lineStyle(0)
            .beginFill(0xFF0000, 1)
            .drawCircle(198, 130, 120)
            .endFill();
        //speaker picture
        this.elements.speakerBPicture = new PIXI.Sprite(speakerFile);
        this.elements.speakerBPicture.interactive = true;
        this.elements.speakerBPicture.buttonMode = true;
        this.elements.speakerBPicture.anchor.set(.5, .5);
        this.elements.speakerBPicture.x = 198;
        this.elements.speakerBPicture.y = 130;
        this.elements.speakerBPicture.scale.x  *= .8;
        this.elements.speakerBPicture.scale.y  *= .8;
        //
        this.elements.speakerBPicture.mask = this.elements.maskB;
        //speaker drap
        this.elements.speakerBPicture
                .on('pointerdown', this.onDragStart)
                .on('pointerup', this.onDragEnd)
                .on('pointerupoutside', this.onDragEnd)
                .on('pointermove', this.onDragMove);
        //speaker name
        this.elements.speakerBName = new PIXI.Text('', {
            fontWeight: 700,
            fontSize: 35,
            fontFamily: 'Lato',
            fill: colors.white,
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 300
        });
        //
        this.elements.speakerBName.anchor.set(0.5, 0);
        this.elements.speakerBName.x = 200;
        this.elements.speakerBName.y = 280;
        //speaker role
        this.elements.speakerBRole = new PIXI.Text('', {
            fontWeight: 700,
            fontSize: 25,
            fontFamily: 'Lato',
            fill: colors.white,
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 300
        });

        this.elements.speakerBRole.anchor.set(0.5, 0);
        this.elements.speakerBRole.x = 200;

        //add to stage
        this.app.stage.addChild(this.elements.box,
                                this.elements.check,
                                this.elements.prices,
                                this.elements.container);
        this.elements.container.addChild(this.elements.phone,
                                    this.elements.welcome,
                                    this.elements.speakerA,
                                    this.elements.speakerB);
        this.elements.speakerA.addChild(this.elements.borderA,
                                    this.elements.maskA,
                                    this.elements.speakerAPicture,
                                    this.elements.speakerAName,
                                    this.elements.speakerARole);
        this.elements.speakerB.addChild(this.elements.borderB,
                                    this.elements.maskB,
                                    this.elements.speakerBPicture,
                                    this.elements.speakerBName,
                                    this.elements.speakerBRole);


        this.first = false;
    }

    canvasTitle(color)
    {
        const exists = this.elements.title ? true : false;
        
        if (exists)
        {
            this.elements.title.text = 'B2B';
            return;
        }

        this.elements.title = new PIXI.Text('B2B', {
                fontWeight: 700,
                fontSize: 240,
                fontFamily: 'Lato',
                fill: color,
                align: 'left',
                wordWrap: true,
                wordWrapWidth: 550
            });

            this.elements.title.x = 55;
            this.elements.title.y = 270;

            this.app.stage.addChild(this.elements.title);
    }

    canvasPrice(priceA, priceB, priceC, color)
    {
        console.log("canvasPrice"+color);
        console.log("textoA"+this.elements.priceA);
        //priceA
        if (this.elements.priceA){
            this.elements.priceA.style.fill = color;
            this.elements.priceA.text = priceA;
        }
        else
        {
            this.elements.priceA = new PIXI.Text(priceA, {
                fontWeight: 700,
                fontSize: 30,
                fontFamily: 'Lato',
                fill: color,
                align: 'left',
                wordWrap: true,
                wordWrapWidth: 396,
                zIndex:1000
            });

            this.elements.priceA.x = 253;
            this.elements.priceA.y = this.elements.prices.y;

            this.app.stage.addChild(this.elements.priceA);
        }
        //priceB
        if (this.elements.priceB){
            this.elements.priceB.text = priceB;
            this.elements.priceB.style.fill = color;
        }
        else
        {
            this.elements.priceB = new PIXI.Text(priceB, {
                fontWeight: 700,
                fontSize: 30,
                fontFamily: 'Lato',
                fill: color,
                align: 'left',
                wordWrap: true,
                wordWrapWidth: 396,
                zIndex:1000
            });

            this.elements.priceB.x = 245;
            this.elements.priceB.y = this.elements.priceA.y + this.elements.priceA.height;

            this.app.stage.addChild(this.elements.priceB);
        }
        //priceC
        if (this.elements.priceC){
            this.elements.priceC.text = priceC;
            this.elements.priceC.style.fill = color;
        }
        else
        {
            this.elements.priceC = new PIXI.Text(priceC, {
                fontWeight: 700,
                fontSize: 30,
                fontFamily: 'Lato',
                fill: color,
                align: 'left',
                wordWrap: true,
                wordWrapWidth: 396,
                zIndex:1000
            });

            this.elements.priceC.x = 314;
            this.elements.priceC.y = this.elements.priceB.y + this.elements.priceB.height;

            this.app.stage.addChild(this.elements.priceC);
        }
    }

    canvasCity(text, color, fontSize)
    {
        const exists = this.elements.city ? true : false;

        if (exists)
        {
            this.elements.city.style.fill = color;
            this.elements.city.text = text;
            this.elements.city.style.fontSize = fontSize;
            return;
        }


            this.elements.city = new PIXI.Text(text, {
                fontWeight: 900,
                fontSize: fontSize,
                fontFamily: 'Lato',
                fill: color,
                align: 'left',
                wordWrap: true,
                wordWrapWidth: 550
            });

            this.elements.city.anchor.set(0, 0.5);
            this.elements.city.x = 65;
            this.elements.city.y = 556;

            this.app.stage.addChild(this.elements.city);
    }

    canvasDate(textA, textB, color)
    {
        const exists = this.elements.date ? true : false;
        const text = textA ? `${textA} - ${textB}` : '';

        if (exists)
        {
            this.elements.date.text = text;
            this.elements.date.style.fill = color;
            return;
        }

            this.elements.date = new PIXI.Text(text, {
                fontWeight: 900,
                fontSize: 60,
                fontFamily: 'Lato',
                fill: color,
                align: 'left',
                wordWrap: true,
                wordWrapWidth: 550
            });

            this.elements.date.x = 65;
            this.elements.date.y = 770;

            this.app.stage.addChild(this.elements.date);
    }

    canvasCheck(text, color)
    {
        const exists = this.elements.hour ? true : false;

        if (exists)
        {
            this.elements.hour.style.fill = color;
            this.elements.hour.text = text;
            return;
        }

        this.elements.hour = new PIXI.Text(text, {
            fontWeight: 900,
            fontSize: 43,
            fontFamily: 'Lato',
            fill: color,
            align: 'left',
            wordWrap: true,
            wordWrapWidth: 550
        });

        this.elements.hour.x = 280;
        this.elements.hour.y = this.elements.check.y;

        this.app.stage.addChild(this.elements.hour);
    }

    canvasPlace(text, color)
    {
        const exists = this.elements.place ? true : false;

        if (exists)
        {
            this.elements.place.style.fill = color;
            this.elements.place.text = text;
            return;
        }

        this.elements.place = new PIXI.Text(text, {
                fontWeight: 900,
                fontSize: 30,
                fontFamily: 'Lato',
                fill: color,
                align: 'left',
                wordWrap: true,
                wordWrapWidth: 550
            });

            this.elements.place.x = 65;
            this.elements.place.y = this.elements.check.y + 70;

            this.app.stage.addChild(this.elements.place);
    }

    canvasAddress(text, color)
    {
        const exists = this.elements.address ? true : false;

        if (exists)
        {
            this.elements.address.style.fill = color;
            this.elements.address.text = text;
            this.elements.address.y = this.elements.place.y + this.elements.place.height;
            return;
        }

        this.elements.address = new PIXI.Text(text, {
                fontWeight: 400,
                fontSize: 30,
                fontFamily: 'Lato',
                fill: color,
                align: 'left',
                wordWrap: true,
                wordWrapWidth: 600
            });

            this.elements.address.x = 65;

            this.app.stage.addChild(this.elements.address);
    }

    canvasPhone(type)
    {
        if (type <= 2)
        {
            this.elements.container.visible = true;
            this.elements.welcome.text = welcomeMessages[type];
        }
        else
            this.elements.container.visible = false;

    }

    canvasPhotos(type, speaker)
    {
        let scale;

        if (type === 1 )
        {
            this.elements.speakerA.x = 0;
            this.elements.speakerA.y = 250;
            this.elements.speakerA.scale.x = 1;
            this.elements.speakerA.scale.y = 1;
            this.elements.speakerB.visible = false;
        }
        else
        {
            this.elements.speakerA.x = 60;
            this.elements.speakerA.y = 200;
            this.elements.speakerA.scale.x = .7;
            this.elements.speakerA.scale.y = .7;
            this.elements.speakerB.visible = true;
        }

        if ( type <= 2 )
        {
            const speakerA = speaker[0] || {}
            scale = speakerA.scale || 1;
            this.elements.speakerAName.text = speakerA.name;
            this.elements.speakerARole.text = speakerA.role;
            this.elements.speakerARole.y = this.elements.speakerAName.y + this.elements.speakerAName.height;
            this.elements.speakerAPicture.scale.x = scale;
            this.elements.speakerAPicture.scale.y = scale;

            if (speakerA.file)
                this.loadImage(speakerA.file)
                .then( res => {
                    this.elements.speakerAPicture.texture = res;
                })
        }
        if ( type === 2 )
        {
            const speakerB = speaker[1] || {}
            scale = speakerB.scale || 1;
            this.elements.speakerB.y = this.elements.speakerA.y + this.elements.speakerA.height + 20;
            this.elements.speakerBName.text = speakerB.name;
            this.elements.speakerBRole.text = speakerB.role;
            this.elements.speakerBRole.y = this.elements.speakerBName.y + this.elements.speakerBName.height;
            this.elements.speakerBPicture.scale.x = scale;
            this.elements.speakerBPicture.scale.y = scale;

            if (speakerB.file )
                this.loadImage(speakerB.file)
                .then( res => {
                    this.elements.speakerBPicture.texture = res;
                })
        }

    }

    onDragStart(event)
    {
        this.draggingData = event.data;
        let position = this.draggingData.getLocalPosition(this);
        this.pivot.set(position.x, position.y);
        this.position.set(this.draggingData.global.x, this.draggingData.global.y);
        this.dragging = true;

        var newPosition = this.draggingData.getLocalPosition(this.parent);
        this.x = newPosition.x;
        this.y = newPosition.y;

    }

    onDragEnd()
    {
        this.dragging = false;
        this.draggingData = null;
    }

    onDragMove()
    {
        if (this.dragging)
        {
            var newPosition = this.draggingData.getLocalPosition(this.parent);
            this.x = newPosition.x;
            this.y = newPosition.y;
        }
    }

    loadImage(src)
    {

        return new Promise ( (resolve, reject) => {
            var reader = new FileReader();
            reader.onload = function(e)
            {
                let file = PIXI.Texture.fromImage(e.target.result);
                resolve(file);
            }
            reader.readAsDataURL(src);
        });
    }

    render()
    {
        return (
            <div
                className='preview'
                ref={ this.myRef }
            >
            </div>
        )
    }

}

Preview.propTypes = propTypes;

export default Preview;